<template>
    <div>
        <!-- <div class="pop_open" @click="showModal">
            <div class="info_icon">
                <SvgHeaderSvg :type="'ask'" />
            </div>
        </div> -->

        <div >
            <Teleport  to="#teleports">
                <div class="modal fade" data-bs-backdrop="true" :id="`modal-${ringBox}`"  tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-body modal-content">                     
                        <div class="">
                            <div class="title_block">
                                <h3 v-if="clarityLabel" class="mb-0 font-active">
                                    {{ clarityLabel }}: <span>{{ item }}</span>
                                </h3>

                                <span @click="notOpenModal"><SvgHeaderSvg type="close" class="largesvg" /></span>
                            </div>
                            <div class="mt-3" >
                                <p class="mb-0">A diamond’s clarity is determined by how flawless the diamond is. The more inclusions and blemishes a diamond has, 
                                    the lower its clarity will be.
                                    The clarity ranges from ‘Flawless’ to ‘Included’.</p>
                                <div class="text-center">
                                    <div class="images my-3" ref="scrollClarityContainer">
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/clarity/si2.svg">
                                            <p :class="{ 'highlight': clairtyHighlighted('SI2') }">SI2</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/clarity/si1.svg">
                                            <p :class="{ 'highlight': clairtyHighlighted('SI1') }">SI1</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/clarity/vs2.svg">
                                            <p :class="{ 'highlight': clairtyHighlighted('VS2') }">VS2</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/clarity/vs1.svg">
                                            <p :class="{ 'highlight': clairtyHighlighted('VS1') }">VS1</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/clarity/vvs2.svg">
                                            <p :class="{ 'highlight': clairtyHighlighted('VVS2') }">VVS2</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/clarity/vvs1.svg">
                                            <p :class="{ 'highlight': clairtyHighlighted('VVS1') }">VVS1</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/clarity/if.svg">
                                            <p :class="{ 'highlight': clairtyHighlighted('IF') }">IF</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/clarity/fl.svg">
                                            <p :class="{ 'highlight': clairtyHighlighted('FL') }">FL</p>
                                        </div>

                                    </div>
                                </div>
                                <p class="mb-0">Our {{ $t('jewelry') }} features VS1-VS2 (Very Slightly Included) clarity graded accent diamonds that contain inclusions that are virtually undetectable to the naked eye.</p>    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </Teleport>
     
     
    </div>
</div>
</template>

<script setup>
    const flagShowModal = ref(false);
    const sideClairty = ref(null);
    const props = defineProps(['item','title','moduleSubType','detailData','type','complete','ringBox'])
    // console.log(props.moduleSubType,'msub');
    // console.log(props.complete,'complete');
    const scrollClarityContainer = ref('');
    const startX = ref(0);
    const isDown = ref(false);
    const scrollLeft = ref(0);

    const clarityRange = computed(()=>{
     
    })

    const active = ref(props.ringBox)
    const notOpenModal = () => {
        emit('close');
        active.value = null;
    };
    const emit = defineEmits(['close']);


    const clairtyHighlighted = (letter) => {
        // let range = clarityRange.value;
        // return range.toUpperCase() === letter.toUpperCase();
        if(props.moduleSubType === 'ring' || props.complete === 'ring' ||  props.moduleSubType === 'earring' || props.complete === 'earring' || props.moduleSubType === 'pendant' || props.complete === 'pendant' || props.detailData === 'band-ring' ||
            props.detailData === 'full-eternity-ring' ||
            props.detailData === 'anniversary-ring' ||
            props.detailData === 'toi-et-moi-ring' ||
            props.detailData === 'couple-bands-ring' ||
            props.detailData === 'tennis-bracelet' ||
            props.detailData === 'fashion-bracelet' ||
            props.detailData === 'fashion-earring' ||
            props.detailData === 'hoop-earring' ||
            props.detailData === 'solitaire-necklace' ||
            props.detailData === 'tennis-necklace' ||
            props.detailData === 'stud-earring' ){

            return letter === 'VS1' || letter === 'VS2';
        }
    };

    const clarityLabel = computed(() => {
    if (
        (props.moduleSubType === 'ring' || props.type === 'preset' || props.detailData === 'in-stock-ring' || props.detailData === 'ring' || props.complete === 'earring' || props.complete === 'pendant' || props.complete === 'ring') &&
        !(['pendant', 'earring'].includes(props.moduleSubType)) &&
        !(props.detailData === 'band-ring' ||
            props.detailData === 'full-eternity-ring' ||
            props.detailData === 'anniversary-ring' ||
            props.detailData === 'toi-et-moi-ring' ||
            props.detailData === 'couple-bands-ring')
    ) {
        return 'Side Stone Clarity';
    } else if (
        props.detailData === 'band-ring' ||
        props.detailData === 'full-eternity-ring' ||
        props.detailData === 'anniversary-ring' ||
        props.detailData === 'toi-et-moi-ring' ||
        props.detailData === 'couple-bands-ring' ||
        props.detailData === 'tennis-bracelet' ||
        props.detailData === 'fashion-bracelet' ||
        props.detailData === 'fashion-earring' ||
        props.detailData === 'hoop-earring' ||
        props.detailData === 'solitaire-necklace' ||
        props.detailData === 'tennis-necklace' ||
        props.detailData === 'stud-earring'
    ) {
            return 'Average Clarity';
        } 
        else if (['pendant', 'earring'].includes(props.moduleSubType)) {
            return 'Accent Stone Clarity';
        }
        return '';
    });

    const scrollToclairtyImage = () => {
        const scroll_Container = scrollClarityContainer.value;
        if (scrollClarityContainer.value) {
            const highlightedElement = scroll_Container.querySelector('.highlight');
            if (highlightedElement) {
                highlightedElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
            }
        }
    };

    const handleScrollclarity = () => {
        scrollToclairtyImage();
    };

    function clarityHorizontalScroll() {
        if (scrollClarityContainer.value) {
            const scroll_Container = scrollClarityContainer.value;
            scroll_Container.addEventListener('mousedown', (e) => {
                isDown.value = true;
                startX.value = e.pageX - scroll_Container.offsetLeft;
                scrollLeft.value = scroll_Container.scrollLeft;
                scroll_Container.classList.add('no-select');
            });

            scroll_Container.addEventListener('mouseleave', () => {
                isDown.value = false;
            });

            scroll_Container.addEventListener('mouseup', () => {
                isDown.value = false;
            });

            scroll_Container.addEventListener('mousemove', (e) => {
                if (!isDown.value) return;
                e.preventDefault();
                const x = e.pageX - scroll_Container.offsetLeft;
                const walk = (x - startX.value) * 2; // Adjust scrolling speed here
                scroll_Container.scrollLeft = scrollLeft.value - walk;
            });
        }
    }
    const showModal = () => {
        flagShowModal.value = true;
        nextTick(() => {
        const modalElement = sideClairty.value;
        if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        modalInstance.show();
        modalElement.addEventListener('shown.bs.modal', () => {
            scrollToclairtyImage();
            }); 
            clarityHorizontalScroll()
    }
        });
    };

    const hideModal = () => {
        const modalElement = sideClairty.value;
        if (modalElement) {
            const modalInstance = bootstrap.Modal.getInstance(modalElement);
            if (modalInstance) {
                modalInstance.hide();
            }
        }
        flagShowModal.value = false;
    };

    onMounted(async()=>{
        await nextTick();
        scrollToclairtyImage();
        handleScrollclarity()
        clarityHorizontalScroll();
    })

    defineExpose({
        scrollToclairtyImage,
    });
</script>



<style scoped>
.highlight {
    color: #668b84;
    font-weight: bold;
    text-decoration: underline;
  }
.largesvg {
    transform: scale(1.3);
    }

.img_box{
    height: 130px;
}

.images {
    display: flex;
    overflow-x: auto; 
    gap: 16px;
    align-items: center;
    cursor: pointer;
}

.images .box {
    flex: 0 0 auto; 
    width: auto; 
    text-align: center;
    user-select: none;
}
.pop_open{
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block{
    display: flex;
    align-items: center;
    justify-content: space-between;
}

p {
    font-size: 16px;
    color: #606060;
}
.image_block{
    text-align: center;
}
.title_block span {
    cursor: pointer;
    color: var(--green);
}

h3 {
    font-size: 22px;
}


.m-info {
    margin: 10px 0;
}
@media(max-width: 767px){
    h3 {
        font-size: 20px;
    }
    p {
        font-size: 14px;
    }
}
/* width */
.images::-webkit-scrollbar {
    width: 5px;
    height: 3px;
  }
  
  /* Track */
  .images ::-webkit-scrollbar-track {
    background: #f5f5f5; 
  }
   
  /* Handle */
  .images::-webkit-scrollbar-thumb {
    background: #c4c4c4; 
    cursor: pointer;
  }
  
  /* Handle on hover */
</style>

